import TodoList from '../assets/Todo-list.png'
import shortLink from '../assets/shortcode-link.png'
import travelAdvisor from '../assets/travel-advisor.png'
import movie from '../assets/movie-database.jpeg'
import Giffy from '../assets/giffy.png'
import batabit from '../assets/batabit.jpg'

export const portfolio = [
    {
        id: 1,
        title: 'Todo-List',
        description: 'Todo-List using React, Context API, and taking advantage of the Hooks and Custom Hooks that React provides us.',
        descriptionEspanih: 'Todo-List usando React, Context API, y aprovechando los Hooks y Custom Hooks que nos proporciona React.',
        img: TodoList,
        website: 'https://todo-list-three-nu.vercel.app/',
        repository: 'https://github.com/mahechahe/todo-list-react'
    },
    {
        id: 2,
        title: 'Landing-page-shrtcode',
        description: 'Web page using the shrtcode API. Made with React, using the main React Hooks. Allows to shorten the links added in the search bar and paint them in the DOM.',
        descriptionEspanih: 'Página web usando la API shrtcode. Hecho con React, usando los principales React Hooks. Permite acortar los enlaces agregados en la barra de búsqueda y pintarlos en el DOM.',
        img: shortLink,
        website: 'https://landing-page-shrtcode.vercel.app/',
        repository: 'https://github.com/mahechahe/landing-page-shrtcode'
    },
    {
        id: 3,
        title: 'Travel-Advisor',
        description: 'Search engine for hotels, restaurants and attractions in all parts of the world, using the APIs of google-maps and Travel advisor, you can search in real time for the places closest to your location and see their awards and location. Made with React and deployed in Vercel.',
        descriptionEspanih: 'Buscador de hoteles, restaurantes y atracciones en todas partes del mundo, utilizando las APIs de google-maps y Travel advisor, puedes buscar en tiempo real los lugares más cercanos a tu ubicación y ver sus premios y ubicación. Hecho con React y desplegado en Vercel.',
        img: travelAdvisor,
        website: 'https://travel-advisor-rosy.vercel.app/',
        repository: 'https://github.com/mahechahe/travel_advisor'
    },
    {
        id: 4,
        title: 'Giffy',
        description: 'Gifs search engine, you can filter, search and view the Gifs of your choice, using the Hooks and Custom Hooks, a fully optimized website and deployed in Vercel.',
        descriptionEspanih: 'Motor de búsqueda de Gifs, puedes filtrar, buscar y visualizar los Gifs de tu preferencia, utilizando los Hooks y Custom Hooks, un sitio web totalmente optimizado y desplegado en Vercel.',
        img: Giffy,
        website: 'https://giff-react.vercel.app/',
        repository: 'https://github.com/mahechahe/giffy-react'
    },
    {
        id: 5,
        title: 'Movie Database',
        description: 'Web page implementing React and managing its Hooks, also connecting to The Movie DataBase API in order to filter the latest movie trends.',
        descriptionEspanih: 'Pagina web implementando React y el manejo de sus Hooks, tambien conectandome a la API The Movie DataBase para asi poder filtrar las ultimas tendencias de peliculas.',
        img: movie,
        website: 'https://movies-tb.vercel.app/',
        repository: 'https://github.com/mahechahe/movies-tb'
    },
    {
        id: 6,
        title: 'Batabit',
        description: 'Web page implementing the best practices as mobile first, created the design from Figma.',
        descriptionEspanih: 'Pagina web implementando las mejores practicas como mobile first, creado el diseño desde Figma.',
        img: batabit,
        website: 'https://mahechahe.github.io/MobileFirst/',
        repository: 'https://github.com/mahechahe/MobileFirst'
    },
    
]